const FETCH_ENTERPRISE_CUSTOMER_ADMIN_REQUEST = 'FETCH_ENTERPRISE_CUSTOMER_ADMIN_REQUEST';
const FETCH_ENTERPRISE_CUSTOMER_ADMIN_SUCCESS = 'FETCH_ENTERPRISE_CUSTOMER_ADMIN_SUCCESS';
const FETCH_ENTERPRISE_CUSTOMER_ADMIN_FAILURE = 'FETCH_ENTERPRISE_CUSTOMER_ADMIN_FAILURE';
const UPDATE_ENTERPRISE_CUSTOMER_ADMIN = 'UPDATE_ENTERPRISE_CUSTOMER_ADMIN';
const DISMISS_ONBOARDING_TOUR_SUCCESS = 'DISMISS_ONBOARDING_TOUR_SUCCESS';
const DISMISS_ONBOARDING_TOUR_FAILURE = 'DISMISS_ONBOARDING_TOUR_FAILURE';
const SET_ONBOARDING_TOUR_DISMISSED = 'SET_ONBOARDING_TOUR_DISMISSED';

export {
  FETCH_ENTERPRISE_CUSTOMER_ADMIN_REQUEST,
  FETCH_ENTERPRISE_CUSTOMER_ADMIN_SUCCESS,
  FETCH_ENTERPRISE_CUSTOMER_ADMIN_FAILURE,
  UPDATE_ENTERPRISE_CUSTOMER_ADMIN,
  DISMISS_ONBOARDING_TOUR_SUCCESS,
  DISMISS_ONBOARDING_TOUR_FAILURE,
  SET_ONBOARDING_TOUR_DISMISSED,
};
